import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'selection-card',
  props: {
  object: {
    type: Object
  },
  firstRow: {
    type: Array,
    default: () => []
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props

function firstRowText () {
  let responseText = ''

  if (props.firstRow && props.firstRow.length > 0 && props.object) {
    props.firstRow.forEach((element: unknown) => {
      responseText += props.object?.[element as string] ?? ''
      if (props.firstRow.indexOf(element) !== props.firstRow.length - 1) {
        responseText += ' - '
      }
    })
  }

  return responseText
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createBlock(_component_v_hover, null, {
    default: _withCtx(({ isHovering, props }) => [
      _createVNode(_component_v_card, _mergeProps({
        flat: "",
        class: { 'on-hover': isHovering && !__props.disabled }
      }, props), {
        default: _withCtx(() => [
          _createVNode(_component_v_card_item, { class: "py-2 px-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, { class: "pa-0 ma-0 d-flex justify-space-between" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(firstRowText()) + " ", 1),
                  (!__props.disabled)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        class: "ml-auto"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-arrow-right")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1040, ["class"])
    ]),
    _: 1
  }))
}
}

})